import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelJuegosView from './PanelJuegosView';
import * as ROUTES from '../../../../router/Routes';

const PanelJuegosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.panelJuegos}
      routes={[ROUTES.juegosDeportivos, ROUTES.juegos]}
    >
      <PanelJuegosView />
    </ContainerTemplate>
  );
};

export default PanelJuegosModule;
